// Vue Router 4 - Vue 3 compatible
import { createRouter, createWebHistory } from "vue-router";

import HomePage from "@/components/homePage.vue";

const Campeonatos = () =>
  import("@/components/Championships/championships.vue");
const NovoCampeonato = () =>
  import("@/components/Championships/newChampionships.vue");
const Entrar = () => import("@/components/Users/login.vue");
const Sair = () => import("@/components/Users/logout.vue");
const Registrar = () => import("@/components/Users/signIn.vue");
const TimesBusca = () => import("@/components/Teams/TimesBusca.vue");
const Perfil = () => import("@/components/Users/users.vue");
const OCampeonato = () =>
  import("@/components/Championships/theChampionship.vue");
const JogoOffline = () => import("@/views/Championship/Paper.vue");
const JogoTempoReal = () =>
  import("@/components/Championships/ChampionshipDetails/onlinePaper.vue");

const DemoModernizacao = () =>
  import("@/components/DemoModernizacao.vue");

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "Home",
      component: HomePage,
    },
    {
      path: "/demo",
      name: "DemoModernizacao",
      component: DemoModernizacao,
    },
    {
      path: "/index.html",
      redirect: "/",
    },
    {
      path: "/campeonatos",
      name: "Campeonatos",
      component: Campeonatos,
      // meta: {
      // auth: true,
      // }
    },
    {
      path: "/campeonatos/novo",
      name: "NovoCampeonato",
      component: NovoCampeonato,
      meta: {
        auth: true,
      },
    },
    {
      path: "/campeonatos/:id",
      name: "OCampeonato",
      component: OCampeonato,
      children: [
        {
          path: "equipes",
          name: "OCampeonatoEquipes",
          component: () =>
            import("./components/Championships/ChampionshipDetails/teams.vue"),
        },
        {
          path: "grupos",
          name: "OCampeonatoGrupos",
          component: () =>
            import("./components/Championships/ChampionshipDetails/groups.vue"),
        },
        {
          path: "jogos",
          name: "OCampeonatoJogos",
          component: () =>
            import(
              "./components/Championships/ChampionshipDetails/gamesRounds.vue"
            ),
          children: [
            {
              path: ":round",
              name: "OCampeonatoRound",
              component: () =>
                import(
                  "./components/Championships/ChampionshipDetails/games.vue"
                ),
            },
          ],
        },
        {
          path: "classificacao",
          name: "OCampeonatoClassific",
          component: () =>
            import(
              "./components/Championships/ChampionshipDetails/classification.vue"
            ),
        },
        {
          path: "estatisticas",
          name: "OCampeonatoEstatisti",
          component: () =>
            import(
              "./components/Championships/ChampionshipDetails/statistics.vue"
            ),
        },
      ],
    },
    {
      path: "/sumula/:id",
      name: "JogoOffline",
      component: JogoOffline,
    },
    {
      path: "/jogo/:id",
      name: "JogoTempoReal",
      component: JogoTempoReal,
    },
    {
      path: "/login",
      name: "Login",
      component: Entrar,
    },
    {
      path: "/logout",
      name: "Logout",
      component: Sair,
    },
    {
      path: "/registrar",
      name: "Registrar",
      component: Registrar,
    },
    {
      path: "/times",
      name: "TimesBusca",
      component: TimesBusca,
    },
    {
      path: "/perfil",
      name: "Perfil",
      component: Perfil,
      meta: {
        auth: true,
      },
    },
  ],
});

export default router;
